import { processTextWithHexCodes } from "@design-lab/shared/ui/MarkdownContent";
import { Sparkles } from "lucide-react";

type PinReadyCardProps = {
  instruction: string;
  compact?: boolean;
};

export function PinReadyCard({ instruction, compact = false }: PinReadyCardProps) {
  return (
    <div
      className={`rounded-lg border border-[#A5B4FC] bg-white shadow-[0px_4px_6px_-2px_rgba(0,0,0,0.05)] ${
        compact ? "p-2" : "p-4"
      }`}
    >
      <div className={`flex items-start ${compact ? "gap-1.5" : "gap-3"}`}>
        <Sparkles
          className={`mt-0.5 shrink-0 text-[#6366F1] ${compact ? "h-3.5 w-3.5" : "h-5 w-5"}`}
        />
        <div className={`flex flex-col ${compact ? "gap-0.5" : "gap-1"}`}>
          <h4 className={`text-xs font-bold uppercase tracking-wide text-[#6366F1]`}>
            OUR DESIGN TEAM WILL MAKE THE FOLLOWING EDIT AFTER CHECKOUT:
          </h4>
          <p className={`text-sm text-gray-700`}>{processTextWithHexCodes(instruction)}</p>
        </div>
      </div>
    </div>
  );
}
